/**
 * Pure helpers shared by the onboarding report, the editor sheet and the
 * ring/heart visuals. No React, no platform code, so both `.tsx` and
 * `.web.tsx` twins and the tests use the same arithmetic.
 *
 * The implementation lives in `@tabbio/utils/cv-health-view`, shared with the
 * public CV Health page on cvhealth.tabbio.com (apps/web), so the app and the
 * site compute identical rings, scores and counts. This module keeps the
 * app's import path and public names stable.
 */
export {
  CV_HEALTH_AREA_ORDER,
  CV_HEALTH_NOT_CHECKED,
  CV_HEALTH_RING_ORDER,
  checkCopyKey,
  computeScore,
  countAreaSuggestions,
  countSuggestions,
  deriveStage,
  findingCopyKey,
  getAreaFindings,
  getCenterValue,
  getNextFinding,
  getRingMode,
  getRingValues,
  hasCheckDetail,
  isFindingActionable,
  isFindingOpen,
  isReportUsable,
  toCountBand,
  toScoreBand,
  type CvHealthCenterValue,
  type CvHealthCountBand,
  type CvHealthNotCheckedFamily,
  type CvHealthRingMode,
  type CvHealthRingValue,
  type CvHealthScoreBand,
} from '@tabbio/utils/cv-health-view';
